const POLLING_INTERVAL_MS = 6_000;
const POLLING_TIMEOUT_MS = 300_000;

interface ValidationStatusApiResponse {
  customStatus: {
    status: 'Completed' | 'Error' | 'Running' | 'Pending';
    total: number;
    current: number;
    errorText?: string;
  };
  output: Array<{
    isXRechnung: boolean;
    isValidationSuccess: boolean;
    message: string;
    fileName: string;
  }>;
}

type StatusFetch = (params: {
  requestConfig: object;
}) => Promise<{ data: { isSuccess: boolean; data: ValidationStatusApiResponse } }>;

export async function pollForFileValidation(statusQueryGetUri: string, statusFetch: StatusFetch): Promise<void> {
  const startedAt = Date.now();

  while (true) {
    if (Date.now() - startedAt > POLLING_TIMEOUT_MS) {
      throw new Error('Validation polling timed out');
    }

    const response = await statusFetch({
      requestConfig: {
        method: 'POST',
        url: 'incidents/GetFileValidationStatus',
        data: { StatusQueryGetUri: statusQueryGetUri }
      }
    });

    if (!response.data.isSuccess) {
      throw new Error('File validation status check failed');
    }

    const { status, errorText } = response.data.data.customStatus;

    const failedValidation = response.data.data.output?.find(item => !item.isValidationSuccess);
    if (failedValidation) {
      throw new Error(failedValidation.message || 'Validation error');
    }

    if (status === 'Completed') return;
    if (status === 'Error') throw new Error(errorText ?? 'Validation error');

    await new Promise<void>(resolve => setTimeout(resolve, POLLING_INTERVAL_MS));
  }
}
